export enum DocumentType {
  //Authorization
  DME = 0,
  PhysicalTherapy = 1,
  OccupationalTherapy = 2,
  InHome = 3,
  InpatientRehab = 4,
  WorkConditioning = 5,
  FCE = 6,
  SurgeryFacility = 7,
  InitialEval = 8,
  TakeoverOfCare = 9,
  WorkHardening = 21,
  PTNote = 22,

  //Global Invoice
  InvoiceInitial = 10,
  InvoiceResend = 11,

  //Claim Types
  BillOut1500 = 12,

  //EOB
  ExplanationOfBenefits = 13,

  //Contracts
  PatientSurgicalContract = 14,
  PatientInjectionContract = 15,

  Upload = 16,

  PatientDemographics = 17,
  InsuranceLetter = 18,

  CMS1500 = 19,
  Combined1500 = 20,

  ClaimDenialLetter = 23,
}
